import { useDropzone } from 'react-dropzone';
import { useCallback, useEffect, useRef, useState } from 'react';
import { Button, Dialog, IconButton, Popover, Tooltip, withStyles } from '@material-ui/core';
import { FileUpload } from './UploadFiles';
import Constant from '@/common/constant/Constant';
import { downloadFileFromS3, getLinkDownloadFileFromS3 } from './FileUploaded';
import OverFlowTooltip from './OverFlowTooltip';
import Utils from '@/common/utils/utils';
import { updatePanelInitData } from '../multiPanel/panel/handler/PanelHandler';
import { cloneDeep } from 'lodash';
import TooltipThumb from './TooltipThumb';
import { I18n } from 'aws-amplify';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { handleOpenTicketDetail, isDisplayHyperLinkFileKnowledge } from '@/component/ticketKnowledge/handler/DetailTicketHandler';
import { PropTypes } from 'prop-types';
import { useSnackbar } from 'notistack';

const ButtonOption = withStyles({
    root: {
        '&:hover': {
            backgroundColor: '#ecf2fb'
        },
        padding: '10px 20px 10px 20px',
        justifyContent: 'flex-start'
    }
})(Button);

const FlagMessageCopyLink = withStyles({
    tooltip: {
        color: '#1DA578',
        backgroundColor: '#D7F4E2',
        padding: '8px 16px',
        fontSize: '14px',
        boxShadow: '6px 5px 5px -4px rgba(0,0,0,0.3)'
    },
    arrow: {
        color: '#D7F4E2'
    }
})(Tooltip);

export const EditFileUploaded = ({
    fileUploadList,
    setFileUploadList,
    fileUpdatedList,
    setValue,
    register,
    listFieldEdited,
    fileDeletedList,
    isEmail,
    acceptedFileExtensions,
    allowMultipleFiles = true,
    limitFileSize,
    note,
    ...props
}) => {
    register(props?.name);
    const [publicForCustomer, setPublicForCustomer] = useState(0);
    const [isDisable, setIsDisable] = useState(false);
    const divRef = useRef(null);
    const isUploadForEmailTicket = props.selectTicketType === Constant.HELPDESK_CREATE_TICKET_TYPE.EMAIL || props.ticketType === Constant.TICKET_TYPE.EMAIL;
    const [openPreviewImage, setOpenPreviewImage] = useState(null);
    const [openOption, setOpenOption] = useState(null);
    const [openFileOption, setOpenFileOption] = useState(null);
    const [isShowFlagMessage, setIsShowFlagMessage] = useState(false);
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        if (props.setShowButtonEditTicket) {
            props.setShowButtonEditTicket();
        }
        
    }, [fileUploadList?.length]);

    useEffect(() => {
        setPublicForCustomer(props.data.structure.publicForCustomer);

        setIsDisable(
            props?.data?.structure?.publicForCustomer === 2 ||
                props?.hasEditFieldPermissions === false ||
                !Utils.isEmptyString(props?.detailTicket?.deletedAt) ||
                props?.detailTicket?.liveOrArchived === Constant.LIVE_OR_ARCHIVED.ARCHIVED ||
                props?.isDisableEdit === true
        );
    }, [
        props.data.structure.publicForCustomer,
        props?.detailTicket,
        props?.hasEditFieldPermissions,
        props?.isDisableEdit
    ]);

    const [defaultValue, setDefaultValue] = useState([]);

    const onDrop = useCallback(
        acceptedFiles => {
            handleDragFileOnChange(acceptedFiles);
            return;
        },
        [fileUploadList, listFieldEdited]
    );

    const handleDefaultValueAndCurrentPanelInitData = () => {
        let fileUpdatedListClone = props.currentPanelInitData.fileUpdatedList;
        let listUrlOfFileUpdated = fileUpdatedListClone.map(file => {
            return file.fileUrl
        });

        let listFileOfFieldValue =Utils.isEmptyArray(props?.defaultValue) ? [] : props?.defaultValue
        let listUrlFileOfFieldValue =  listFileOfFieldValue.map(file => {
            return file.fileUrl
        });

        let listFileOfDefaultValue = [];

        fileUpdatedListClone?.forEach((file) => {
            if(listUrlFileOfFieldValue.includes(file.fileUrl)){
                listFileOfDefaultValue.push(file)
            }
        })

        listFileOfFieldValue?.forEach((file) => {
            if(!listUrlOfFileUpdated.includes(file.fileUrl)){
                listFileOfDefaultValue.push(file)
            }
        })

        return listFileOfDefaultValue
    }

    useEffect(() =>{
        if(props.currentPanelInitData && !Utils.isEmptyObject(props.currentPanelInitData)) {
            if (props.currentPanelInitData.fileUploadList) {
                setFileUploadList(props.currentPanelInitData.fileUploadList);
                props?.setShowButtonEditTicket && props?.setShowButtonEditTicket(); 
            }
        }

    }, [])

    const filterDefaultValue = value => {
        let newValue = [];
        let newFileUploadedList = !Utils.isEmptyArray(fileDeletedList)
            ? value.filter(
                  item =>
                      !Utils.isImageFile(item.fileName) &&
                      !fileDeletedList.find(i => i.fileUrl === item.fileUrl)
              )
            : value.filter(item => !Utils.isImageFile(item.fileName));
        // get list image
        let fileImageList = !Utils.isEmptyArray(fileDeletedList)
            ? value.filter(
                  item =>
                      Utils.isImageFile(item.fileName) &&
                      !fileDeletedList.find(i => i.fileUrl === item.fileUrl)
              )
            : value.filter(item => Utils.isImageFile(item.fileName));
        newValue = [...newFileUploadedList, ...fileImageList];
        return newValue;
    };

    useEffect(() => {
        if (props.ticketType === Constant.TICKET_TYPE.EMAIL_REPLY) return;
        if (!props?.defaultValue || Utils.isEmptyArray(props?.defaultValue) || typeof props?.defaultValue === 'string') {
            setDefaultValue([]);
            props.setFileUpdatedList([]);
            return;
        };

        if(props.currentPanelInitData && !Utils.isEmptyObject(props.currentPanelInitData) && !Utils.isEmptyArray(props.currentPanelInitData.fileUpdatedList)) {
            let defaultValueData = handleDefaultValueAndCurrentPanelInitData();

            // Update HyperlinkIcon FileKnowledge when existed
            defaultValueData = defaultValueData.map(valueData => {
                let updateValueData = {...valueData}
                if (valueData.isPdf) {
                    for (let i = 0; i < props?.defaultValue?.length; i++) {
                        const newValueData = props?.defaultValue[i];
                        if (newValueData.fileUrl === updateValueData.fileUrl && newValueData.idTicketFileKnowledge) {
                            updateValueData = {...newValueData}
                        }
                    }
                }
                return updateValueData
            })

            setDefaultValue(filterDefaultValue(defaultValueData));
            props.setFileUpdatedList(defaultValueData);
        } else {
            setDefaultValue(filterDefaultValue([...props?.defaultValue]));
            props.setFileUpdatedList([...props?.defaultValue]);
            if (!isEmail) {
               updatePanelInitData(props.panelId, props.tabId, props.panelInitData, props.setPanelInitData, 'fileUpdatedList', [...props?.defaultValue]); 
            }
        }
        
        if (!Utils.isEmptyArray(...props?.defaultValue)) {
            setValue(props?.name, 'fileUploaded');
            props.clearErrors(props?.name);
        } else {
            setValue(props?.name, '');
        }
    }, [props?.defaultValue]);

    useEffect(() => {
        if (props.ticketType === Constant.TICKET_TYPE.EMAIL_REPLY) return;
        if ((!Utils.isEmptyArray(fileUploadList) || !Utils.isEmptyArray(props?.defaultValue)) && isUploadForEmailTicket && props.setErrorCreateTicket) {
            let totalFileSize = 0;
            fileUploadList.forEach(file => {
                if (file?.file?.size) {
                    totalFileSize += parseInt(file?.file?.size);
                }
            })
            let defaultValueFile = props?.defaultValue;
            if (!Utils.isEmptyArray(defaultValueFile)) {
                defaultValueFile.forEach(file => {
                    if (file?.fileSize) {
                        totalFileSize += parseInt(file?.fileSize);
                    }
                })
            }

            if (totalFileSize) {
                let convertTotalFileSizeToMB = Utils.convertByteToMB(totalFileSize)
                if (convertTotalFileSizeToMB > Constant.LIMIT_VALUE_VALIDATE.MB_FILE_UPLOAD_FOR_EMAIL_TICKET) {
                    props.setErrorCreateTicket(
                        props?.name,
                        { type: 'manual', message: I18n.get('MGS-FILE-OVER-CAPACITY').replace('{{fileSize}}', Constant.LIMIT_VALUE_VALIDATE.MB_FILE_UPLOAD_FOR_EMAIL_TICKET) },
                        { shouldFocus: true }
                    );
                }
            } else {
                props.clearErrors(props?.name); 
            }
        } else {
            props.clearErrors(props?.name);
        }
    }, [fileUploadList, props?.defaultValue]);

    // uef to ONLY EMAIL_REPLY (because: too many re-render if use common's uef)
    useEffect(() => {
        if (props.ticketType !== Constant.TICKET_TYPE.EMAIL_REPLY) return;

        setDefaultValue(filterDefaultValue([...props?.defaultValue]));
        if (!isEmail) {
            props.setFileUpdatedList([...props?.defaultValue]);
            updatePanelInitData(props.panelId, props.tabId, props.panelInitData, props.setPanelInitData, 'fileUpdatedList', [...props?.defaultValue]);
        }
    }, [props?.isTriggerReloadCurrentTicket, fileDeletedList, props?.defaultValue])

    const getErrorMessage = useCallback((errorCode) => {
        switch (errorCode) {
            case Constant.UPLOAD_FILE_ERROR_CODE.FILE_TOO_LARGE:
                return I18n.get('ERROR_MESSAGE_OVER_FILE_SIZE').replace('{fileSize}', `${limitFileSize}MB`);
            case Constant.UPLOAD_FILE_ERROR_CODE.FILE_INVALID_TYPE:
                return I18n.get('ERROR_MESSAGE_INVALID_FORMAT_FILE');
            case Constant.UPLOAD_FILE_ERROR_CODE.TOO_MANY_FILES:
                return I18n.get('ERROR_MESSAGE_OVER_AMOUNT_FILE').replace('{amountFile}', '1');
            default:
                return 'Unknown file error';
        }
    }, [limitFileSize]);

    const showErrorSnackbar = useCallback((message) => {
        enqueueSnackbar(message, { 
            variant: 'error',
            autoHideDuration: 2000 
        });
    }, [enqueueSnackbar]);

    const handleRejectedFiles = useCallback((rejectedFiles) => {
        if (!rejectedFiles || rejectedFiles.length === 0) return;

        rejectedFiles.forEach((rejected) => {
            if (rejected.errors && rejected.errors.length) {
                rejected.errors.forEach(error => {
                    const errorMessage = getErrorMessage(error.code) || error.message;
                    showErrorSnackbar(errorMessage);
                });
            }
        });
    }, [getErrorMessage, showErrorSnackbar]);

    const handleDrop = useCallback((acceptedFiles, rejectedFiles) => {
        
        if (!allowMultipleFiles &&!Utils.isEmptyArray(acceptedFiles) && !Utils.isEmptyArray(rejectedFiles)) {
            handleRejectedFiles(rejectedFiles);
            return;
        }
        
        // Handle accepted files
        onDrop(acceptedFiles);
        
        // Handle rejected files
        handleRejectedFiles(rejectedFiles);
    }, [allowMultipleFiles, onDrop, handleRejectedFiles]);

    const { getRootProps, getInputProps } = useDropzone({ 
        onDrop: handleDrop,
        disabled: isDisable,
        accept: acceptedFileExtensions && acceptedFileExtensions.length > 0 ? acceptedFileExtensions.join(',') : undefined,
        multiple: !!allowMultipleFiles,
        maxSize: limitFileSize ? limitFileSize * 1024 * 1024 : undefined,
    });

    const handleDragFileOnChange = fileList => {
        const tempFileUploadList = [];
        const structureForm = Utils.convertJSONDataToObject(props.parentForm?.structure);

        // Process all files first
        for (const file of fileList) {
            if (file) {
                const type = file.type;
                const fileUpload = {
                    file: file,
                    progress: 0,
                    status: true,
                    key: '',
                    splitPdf: Boolean(structureForm?.splitPdf),
                    isExpand: true,
                    isPdf: type === 'application/pdf'
                };
                tempFileUploadList.push(fileUpload);
            }
        }

        // Only proceed if there are files to upload
        if (!allowMultipleFiles && Utils.isEmptyArray(tempFileUploadList)) {
            return;
        }
        // Determine new file upload list based on multiple files setting
        const newFileUploadList = allowMultipleFiles 
            ? [...fileUploadList, ...tempFileUploadList]
            : [...tempFileUploadList];

        if (!allowMultipleFiles && !Utils.isEmptyArray(tempFileUploadList)) {
            // handle delete existingFiles & uploadedFiles
            const existingFiles = [...defaultValue];
            if (!Utils.isEmptyArray(existingFiles) && props?.setFileDeletedList) {
                existingFiles.forEach(file => {
                    props.setFileDeletedList(prev => [...prev, { ...file, isDelete: true }]);
                });
            }            
            if (!Utils.isEmptyArray(existingFiles)) {
                const deletedFiles = existingFiles.map(file => ({ ...file, isDelete: true }));
                if (props?.setFileUpdatedList) {
                    props?.setFileUpdatedList(prev => [...prev, ...deletedFiles])
                }
                if (props?.setFileDeletedList) {
                    props?.setFileDeletedList(prev => [...prev, ...deletedFiles])
                }
            }
            
            if (props?.setFileUpdatedList) {
                props?.setFileUpdatedList(prev => [...prev].map(p => ({...p, isDelete: true})));
            }
            setDefaultValue([]);
        }

        // Update form edit state
        if (props?.setIsEdited) {
            if (props?.setOnChangeEdit) {
                props.setOnChangeEdit(!props.onChangeEdit);
            }
            props.setIsEdited(true);
            
            const newFieldEdited = listFieldEdited?.filter(id => 
                id !== 'attachment' && id !== 'suffixOfAttachments'
            ) || [];
            
            props.setListFieldEdited([...newFieldEdited, 'attachment', 'suffixOfAttachments']);
        }
        
        // Update file upload list and form values
        setFileUploadList(newFileUploadList);
        setValue(Constant.FORM_FILE_UPLOAD_LIST_INPUT_NAME, newFileUploadList);

        // Update field value based on whether files were uploaded
        if (!Utils.isEmptyArray(tempFileUploadList)) {
            setValue(props?.name, 'fileUploaded');
            props.clearErrors(props?.name);
        } else {
            setValue(props?.name, '');
        }

        // Trigger button edit ticket callback
        props?.setShowButtonEditTicket?.();
    };

    const handleDeleteFile = index => {
        setOpenOption(null);
        setOpenFileOption(null);
        let newFileUploadList = cloneDeep(fileUploadList);
        if (newFileUploadList[index]) {
            newFileUploadList.splice(index, 1);
        }

        if (props?.setIsEdited) {
            if(props?.setOnChangeEdit){
                    props?.setOnChangeEdit(!props.onChangeEdit)
                }
            props?.setIsEdited(true);
            let newFieldEdited = listFieldEdited?.filter(id => {
                return id !== 'attachment' && id !== 'suffixOfAttachments';
            });
            newFieldEdited = Utils.isEmptyArray(newFieldEdited) ? [] : newFieldEdited;
            props?.setListFieldEdited([...newFieldEdited, 'attachment', 'suffixOfAttachments']);
        }

        setValue(Constant.FORM_FILE_UPLOAD_LIST_INPUT_NAME, newFileUploadList);
        setFileUploadList([...newFileUploadList]);
        props?.setShowButtonEditTicket && props?.setShowButtonEditTicket();
        if(!Utils.isEmptyArray(newFileUploadList)) {
            setValue(props?.name, 'fileUploaded');
            props.clearErrors(props?.name);
        } else {
            setValue(props?.name, '');
        }
    };

    const isDisplayConvertPDFEditFunction = (isPdf = false) => {
        const isServicesPDFOfCorpOn = props.detailTicket?.convertPDFOrg === 1 ? true : false;
        const commonCondition = Utils.isEmptyString(props.detailTicket?.deletedAt) && props?.isDisplaySplitPdfSwitch && isPdf && isServicesPDFOfCorpOn;
    
        if(props.detailTicket?.public !== Constant.TICKET_PUBLIC.DRAFT) {
            return props.hasEditFieldPermissions === true && commonCondition;
        }
        return commonCondition;
    }

    const onChangePdf = (index) => {
        props.setIsEdited(true);
        setFileUploadList(prev => {
            const prevClone = cloneDeep(prev);
            prevClone[index].splitPdf = !prev[index].splitPdf;
            setValue(Constant.FORM_FILE_UPLOAD_LIST_INPUT_NAME, prevClone);
            return prevClone;
        })
    }

    const onChangePdfFileUploaded = (index) => {
        props.setIsEdited(true);
        setDefaultValue(prev => {
            const prevClone = cloneDeep(prev);
            prevClone[index].splitPdf = !prev[index].splitPdf;
            if(!prev[index]?.isPdf) prevClone[index].isPdf = Utils.isNameOrUrlOfPdfFile(prev[index]?.fileName)
            return prevClone;
        })
        
        props.setFileUpdatedList(prev => {
            const prevClone = cloneDeep(prev);
            prevClone[index].splitPdf = !prev[index].splitPdf;
            if(!prev[index]?.isPdf) prevClone[index].isPdf = Utils.isNameOrUrlOfPdfFile(prev[index]?.fileName)
            return prevClone;
        })
    }

    const onClickToggleExpandedPdf = (index) => {
        setFileUploadList(prev => {
            const prevClone = cloneDeep(prev);
            prevClone[index].isExpand = !prev[index].isExpand;
            return prevClone;
        })
    }

    const onClickToggleFileUploadedExpandedPdf = (index) => {
        setDefaultValue(prev => {
            const prevClone = cloneDeep(prev);
            prevClone[index].isExpand = !prev[index].isExpand;
            return prevClone;
        })
    }

    const renderFiledUpload = () => {
        let contentChatList = [];
        if (Utils.isEmptyString(props.detailTicket?.deletedAt)) {
            fileUploadList.forEach((fileUploadInfor, index) => {
                const isPdf = fileUploadInfor.isPdf;
                const splitPdf = fileUploadInfor.splitPdf;
                let item = { content: fileUploadInfor.file.name, fileSize: fileUploadInfor.file.size };
                let url = '';
                if (fileUploadInfor.file instanceof File || fileUploadInfor.file instanceof Blob) {
                    url = URL.createObjectURL(fileUploadInfor.file);
                } else if (typeof fileUploadInfor.file === 'string') {
                    url = fileUploadInfor.file;
                } else if (typeof fileUploadInfor.file === 'object' && fileUploadInfor.isDuplicate) {
                    url = getLinkDownloadFileFromS3(
                        {
                            ...fileUploadInfor.file,
                            type: Constant.S3_FILE_TYPE.TICKET_FILE,
                        },
                        props.detailTicket,
                        null,
                        Constant.ATTACH_FILE.VIEW_TICKET_DETAIL
                    );
                }

                contentChatList.push(
                    <>
                        <li>
                            {Utils.isImageFile(fileUploadInfor.file.name) ? (
                                <div
                                    className="class-relative cursor-default listmap-item"
                                    style={{ display: 'flex', gap: 5 }}
                                >
                                    <TooltipThumb
                                        value={`${item.content}(${formatBytes(item.fileSize)})`}
                                        className="titleDisplay"
                                    >
                                        <img
                                            alt=""
                                            src={url}
                                            style={{
                                                height: 50,
                                                width: 70,
                                                objectFit: 'cover'
                                            }}
                                            onClick={() => setOpenPreviewImage(url)}
                                        />
                                    </TooltipThumb>
                                    <div
                                        style={{
                                            height: 50,
                                            backgroundColor: '#ecedef',
                                            width: 20,
                                            cursor: 'pointer',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center'
                                        }}
                                        onClick={e => {
                                            setOpenFileOption({ ...item, index, isNewImg: true });
                                            setOpenOption(e.currentTarget);
                                        }}
                                    >
                                        <img src="/assets/image/icon-more-panel.svg" alt="" />
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <FileUpload
                                        key={index}
                                        fileUploadInfor={fileUploadInfor}
                                        fileUploading={props.fileUploading}
                                        chatPost={item}
                                        isPdf={isPdf}
                                        onClickToggleExpandedPdf={() =>
                                            onClickToggleExpandedPdf(index)
                                        }
                                        isDisplaySplitPdfSwitch={props?.isDisplaySplitPdfSwitch}
                                    ></FileUpload>
                                    <div className="lstName-item">
                                        <IconButton
                                            disabled={isDisable}
                                            onClick={() => handleDeleteFile(index)}
                                            className="itemDelete"
                                        >
                                            <img src="/assets/image/dustbox_b.png" alt="" />
                                        </IconButton>
                                    </div>
                                </>
                            )}
                        </li>

                        {isPdf && props?.isDisplaySplitPdfSwitch && (
                            <>
                                <div
                                    className={`setting-item-group ${!fileUploadInfor?.isExpand &&
                                        'setting-item-group-none'}`}
                                    key={index}
                                >
                                    <div className="setting-children-item setting-pdf-file-item">
                                        <label className="setting-label">
                                            {I18n.get('LABEL-SPLIT-PDF-INTO-PAGES')}
                                        </label>
                                        <div className="switch-check">
                                            <input
                                                type="checkbox"
                                                id={`switch-pdf-mode-${index}`}
                                                checked={splitPdf}
                                                onChange={() => onChangePdf(index)}
                                                disabled={isDisable}
                                            />
                                            <label htmlFor={`switch-pdf-mode-${index}`}></label>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </>
                );
            });
        }
        return contentChatList;
    };

    const formatBytes = (bytes, decimals = 2) => {
        if (!+bytes) return '0 B'
    
        const k = 1024
        const dm = decimals < 0 ? 0 : decimals
        const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    
        const i = Math.floor(Math.log(bytes) / Math.log(k))
    
        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
    }


    const deleteFile = index => {
        setOpenOption(null);
        setOpenFileOption(null);
        let defaultValueTmp = cloneDeep(defaultValue);
        if (defaultValueTmp[index]) {
            defaultValueTmp.splice(index, 1);
        }
        if (props?.setIsEdited) {
            if(props?.setOnChangeEdit){
                    props?.setOnChangeEdit(!props.onChangeEdit)
                }
            props?.setIsEdited(true);
            props?.setShowButtonEditTicket && props?.setShowButtonEditTicket();
            let newFieldEdited = listFieldEdited?.filter(id => {
                return id !== 'attachment' && id !== 'suffixOfAttachments';
            });
            newFieldEdited = Utils.isEmptyArray(newFieldEdited) ? [] : newFieldEdited;
            props?.setListFieldEdited([...newFieldEdited, 'attachment', 'suffixOfAttachments']);
        }
        const fileDeletedList = defaultValue[index];
        if (props?.setFileDeletedList) {
            props?.setFileDeletedList(prev => [...prev, {...fileDeletedList, isDelete: true}])
        }
        setDefaultValue([...defaultValueTmp]);
        if(!Utils.isEmptyArray(fileUpdatedList)){
            let fileUpdatedListClone = fileUpdatedList?.filter((file => file.isDelete));
            fileUpdatedListClone.push({ ...fileDeletedList, isDelete: true });
            props.setFileUpdatedList([...defaultValueTmp, ...fileUpdatedListClone]);
        }else{
            props.setFileUpdatedList([...defaultValueTmp, { ...fileDeletedList, isDelete: true }]);
        }
    };

    const isDisplayBoxUploadFile = () => {
        // Don't show drag & drop area in view mode
        if (props?.hasEditFieldPermissions === false) {
            return false;
        }

        if (!Utils.isEmpty(props.addTicket)) {
            return true;
        }

        if (props.componentName === Constant.COMPONENT_NAME.DETAIL_TICKET_KNOWLEDGE) {
            return props?.hasEditFieldPermissions;
        }

        return publicForCustomer === Constant.SETTING_PUBLIC_FOR_CUSTOMER.EDITABLE;
    }

    const renderFileImageUpload = (fileImageList, imageLength) => {
        return (
            <div style={{ display: 'flex', gap: 15, flexWrap: 'wrap' }}>
                {fileImageList
                    .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
                    .map((item, index) => {
                        const thumbnailInfo =
                            item?.thumbnailInfo ||
                            props?.detailTicket?.attachFiles?.find(
                                att => att?.fileInfo?.fileUrl === item.fileUrl
                            )?.thumbnailInfo;
                        const imgThumbnailLink = getLinkDownloadFileFromS3(
                            {
                                ...item,
                                type: Constant.S3_FILE_TYPE.TICKET_FILE,
                                thumbnailInfo: JSON.stringify(thumbnailInfo)
                            },
                            props.detailTicket,
                            null,
                            Constant.ATTACH_FILE.VIEW_TICKET_DETAIL
                        );

                        const imgLink = getLinkDownloadFileFromS3(
                            {
                                ...item,
                                type: Constant.S3_FILE_TYPE.TICKET_FILE,
                                thumbnailInfo: null
                            },
                            props.detailTicket
                        );
                        return (
                            <li key={item.id} className="justify-content-center">
                                <div className="display-thumb">
                                    <div
                                        className="class-relative cursor-default"
                                        style={{ display: 'flex', gap: 5 }}
                                    >
                                        <TooltipThumb
                                            value={`${item.fileName}(${formatBytes(
                                                item.fileSize
                                            )})`}
                                            className="titleDisplay"
                                        >
                                            <img
                                                style={{
                                                    height: 50,
                                                    width: 70,
                                                    objectFit: 'cover',
                                                    cursor: 'pointer'
                                                }}
                                                src={
                                                    Utils.isImageFile(item.fileName)
                                                        ? imgThumbnailLink
                                                        : '/assets/image/others_file.png'
                                                }
                                                alt=""
                                                aria-label="more"
                                                aria-controls="long-menu"
                                                aria-haspopup="true"
                                                onClick={() => {
                                                    setOpenPreviewImage(imgLink);
                                                }}
                                            />
                                        </TooltipThumb>
                                        <div
                                            style={{
                                                height: '100%',
                                                backgroundColor: '#ecedef',
                                                width: 20,
                                                cursor: 'pointer',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center'
                                            }}
                                            onClick={e => {
                                                setOpenFileOption({
                                                    ...props.detailTicket.attachFiles.find(
                                                        i => i.fileInfo.fileUrl === item?.fileUrl
                                                    ),
                                                    index,
                                                    imageLength
                                                });
                                                setOpenOption(e.currentTarget);
                                            }}
                                        >
                                            <img src="/assets/image/icon-more-panel.svg" alt="" />
                                        </div>
                                    </div>
                                </div>
                            </li>
                        );
                    })}
            </div>
        );
    };

    const renderFileUploaded = fileUploadedList => {
        let newFileUploadedList = fileUploadedList
            .filter(item => !Utils.isImageFile(item.fileName) && !item.isDelete)
            .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));

        // get list image
        let fileImageList = fileUploadedList.filter(item => Utils.isImageFile(item.fileName));
        fileImageList = fileImageList.filter((file) => !file.isDelete )
        fileImageList = Utils.sortByCreatedAtAsc(fileImageList);
        let fileNotImageLength = newFileUploadedList.length;
        let fileUploadedComponentList = [];

        newFileUploadedList?.forEach((file,index) => {
            let isPdf = file.isPdf ? file.isPdf : Utils.isNameOrUrlOfPdfFile(file?.fileName);
            let splitPdf = file?.splitPdf ? file.splitPdf : false;    

            let defaultFileData = {};
            if (props.defaultValue && !Utils.isEmptyArray(props.defaultValue)) {
                defaultFileData = props.defaultValue.find(fileDefault => fileDefault.fileUrl === file.fileUrl)
            }
            let defaultSplitPdf = defaultFileData?.splitPdf ? defaultFileData?.splitPdf : false;
            
            fileUploadedComponentList.push(
                <>
                    <li>
                        {isDisplayConvertPDFEditFunction(isPdf) && (
                            <ArrowDropDownIcon
                                onClick={() => onClickToggleFileUploadedExpandedPdf(index)}
                                className={`${
                                    isDisplayConvertPDFEditFunction(isPdf)
                                        ? file?.isExpand
                                            ? 'icon-pdf-expand'
                                            : 'icon-pdf-collapse'
                                        : 'icon-pdf-collapse'
                                }`}
                            />
                        )}
                        {(
                            <a
                                className="file-upload-name--change file-upload-active"
                                target="_blank"
                                onClick={e => {
                                    downloadFileFromS3({ type: 1, ...file }, props.detailTicket, false, false, '', props?.setIsShowPopupLogout);
                                }}
                            >
                                <OverFlowTooltip
                                    value={`${file.fileName}(${formatBytes(file.fileSize)})`}
                                    className={'link-file-name'}
                                ></OverFlowTooltip>
                            </a>
                        )}
                        {
                            !isDisable &&
                            (
                            <div className="lstName-item">
                                <IconButton
                                    disabled={isDisable}
                                    onClick={() => deleteFile(index)}
                                    className="itemDelete"
                                >
                                    <img src="/assets/image/icon-closeUpfile.svg" alt="" />
                                </IconButton>
                            </div>
                            )
                        }

                        {/* Link FileKnowledgeDetail */}
                        {isDisplayHyperLinkFileKnowledge(
                            file,
                            props.detailTicket?.convertPDFOrg
                        ) && (
                            <Tooltip
                                title={I18n.get('ファイルナレッジを表示')}
                                aria-label={I18n.get('ファイルナレッジを表示')}
                            >
                                <div
                                    className="file-knowledge-ticket-link"
                                    onClick={() =>
                                        handleOpenTicketDetail(
                                            file.idTicketFileKnowledge,
                                            Constant.TICKET_TYPE.PDF_FILE_KNOWLEDGE,
                                            '',
                                            '',
                                            props?.setIsLoading,
                                            props?.currentUserDetail,
                                            props?.projectInuseDetail,
                                            props?.setIsOpenAccessDeniedPopup,
                                            props?.addNewPanel,
                                            props?.panelId,
                                            props?.isCustomer
                                        )
                                    }
                                >
                                    <img src="/assets/image/icon-show-file-knowledge.svg" alt="" />
                                </div>
                            </Tooltip>
                        )}
                    </li>
                    {isDisplayConvertPDFEditFunction(isPdf) && (
                        <div
                            className={`setting-item-group ${!file?.isExpand &&
                                'setting-item-group-none'}`}
                            key={index}
                        >
                            <div className="setting-children-item setting-pdf-file-item">
                                <label className="setting-label">
                                    {I18n.get('LABEL-SPLIT-PDF-INTO-PAGES')}
                                </label>
                                <div className="switch-check">
                                    <input
                                        type="checkbox"
                                        id={`file-uploaded-switch-pdf-mode-${index}`}
                                        checked={splitPdf}
                                        onChange={() => onChangePdfFileUploaded(index)}
                                        disabled={isDisable || defaultSplitPdf}
                                    />
                                    <label
                                        htmlFor={`file-uploaded-switch-pdf-mode-${index}`}
                                    ></label>
                                </div>
                            </div>
                        </div>
                    )}
                </>
            );
        });
        let fileImageComponentList = renderFileImageUpload(fileImageList, fileNotImageLength)

        fileUploadedComponentList = [...fileUploadedComponentList, fileImageComponentList];

        return fileUploadedComponentList;
    };
    
    const isCustomerHasFileUpload = (fileUploadedList) => {
        if (!Utils.isEmpty(props.addTicket)) {
            return false;
        }

        return props.componentName !== Constant.COMPONENT_NAME.DETAIL_TICKET_KNOWLEDGE && 
        publicForCustomer !== Constant.SETTING_PUBLIC_FOR_CUSTOMER.EDITABLE && 
        fileUploadedList.length <= 0
    }

    const isCustomerKnowledgeHasFileUpload = (fileUploadedList) => {
        if (!Utils.isEmpty(props.addTicket)) {
            return false;
        }

        return props.componentName === Constant.COMPONENT_NAME.DETAIL_TICKET_KNOWLEDGE && 
        !props?.hasEditFieldPermissions && 
        fileUploadedList.length <= 0
    }

    const renderLabel = fileUploadedList => {
        // Don't show title in view mode when there's no data
        if (props?.hasEditFieldPermissions === false && fileUploadedList.length <= 0) {
            return '';
        }

        if (
            isCustomerHasFileUpload(fileUploadedList) ||
            isCustomerKnowledgeHasFileUpload(fileUploadedList)
        ) {
            return '';
        }

        return (
            <>
                <div className="cell-prod-status gap-8">
                    {props?.isTooltipTitle ? (
                        <div className="d-flex">
                            <Tooltip title={props?.label}>
                                <span className="form-addTicket-label text-truncate">
                                    <label
                                        className={
                                            'text-truncate line-height-18' +
                                            (publicForCustomer
                                                ? 'form-addTicket-label-color'
                                                : 'form-addTicket-label')
                                        }
                                    >
                                        {props?.label}
                                    </label>
                                </span>
                            </Tooltip>
                            {props.data.structure.required && (
                                <span className="required padding-left-4">*</span>
                            )}
                        </div>
                    ) : (
                        <label
                            className={
                                publicForCustomer
                                    ? 'form-addTicket-label-color'
                                    : 'form-addTicket-label'
                            }
                        >
                            {props?.label}
                            {props.data.structure.required && (
                                <span className="required">*</span>
                            )}
                        </label>
                    )}
                    {props?.isShowIconCopyFieldId && (
                        <Tooltip title={props?.data.id} placement="top" arrow>
                            <img
                                src="/assets/image/icon-copy.svg"
                                alt="copy"
                                onClick={() => navigator.clipboard.writeText(props?.data.id)}
                            />
                        </Tooltip>
                    )}
                </div>
                {note && <span className='font-size-13' style={{ display: 'block' }}>{note}</span>}
            </>
        );
    };


    const preventOpenNewTab = (e) => {
        if (isDisable) {
            e.nativeEvent.preventDefault();
            if (!e) return;
        }
    }

    const preventDraggingOpenNewTab = {
        onDrop: e => preventOpenNewTab(e)
    }

    const isEmptyUploadFile = () => {
        if (!props.data.structure.required) return false;
        if (!Utils.isEmptyArray(fileUploadList)) return false;
        let isEmptyAfterEdit = false;
        if (!Utils.isEmptyArray(fileUpdatedList)) {
            let listNotDelete = fileUpdatedList.filter(file => !file.isDelete);
            if (Utils.isEmptyArray(listNotDelete)) {
                isEmptyAfterEdit = true;
            }
        }
        
        return !props.isDuplicate && isEmptyAfterEdit;
    }

    const onClickCopyShareLink = useCallback(() => {
        const linkUrl = Utils.getShareLinkImg({
            attachFile: openFileOption,
            dataShareLink: props.detailTicket.dataShareLink
        });

        navigator.clipboard.writeText(linkUrl);
        setIsShowFlagMessage(true);
        setTimeout(() => {
            setIsShowFlagMessage(false);
        }, 3000);
    }, [props.detailTicket, openFileOption]);

    return (
        <div className="form-addTicket">
            {renderLabel(defaultValue)}
            <div className="form-addTicket-input" ref={divRef}>
                <div className="lstName-file">
                    <ul>{renderFiledUpload()}</ul>
                    <ul>{!props.isDuplicate && renderFileUploaded(defaultValue)}</ul>
                </div>

                {isDisplayBoxUploadFile() && (
                    <div
                        className="formUpload"
                        {...getRootProps()}
                        {...(isDisable ? preventDraggingOpenNewTab : {})}
                        data-cy="drop-file-input-upload"
                    >
                        <input disabled={isDisable} {...getInputProps()} />
                        <label htmlFor="contained-button-file">
                            <Button disabled={isDisable} variant="contained" component="span">
                                <div className="formUpload-item">
                                    <img src="/assets/image/icon-upload.svg" alt="" />
                                    <span
                                        className={`${
                                            isDisable ? 'fields-disabled' : ''
                                        } formUpload-txt`}
                                    >
                                        {I18n.get('MSG-DRAG-DROP-FILE')}
                                    </span>
                                </div>
                            </Button>
                        </label>
                    </div>
                )}
                {props?.errorlist && props.errorlist[props.name]?.message && (
                    <div className="upload-file-error 1111">
                        {props.errorlist[props.name]?.message}
                    </div>
                )}

                {props.attachmentError && !Utils.isEmptyString(props.attachmentError) && (
                    <div className="upload-file-error pt-3">{props.attachmentError}</div>
                )}

                {isEmptyUploadFile() && (
                    <div className="upload-file-error pt-3">{`入力形式に誤りがあります`}</div>
                )}
            </div>

            <Popover
                open={Boolean(openOption) || false}
                anchorEl={openOption}
                onClose={() => {
                    setOpenFileOption(null);
                    setOpenOption(null);
                }}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left'
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    {openFileOption?.shortKey && !Utils.isEmptyObject(props.detailTicket?.dataShareLink) && (
                        <FlagMessageCopyLink
                            title={I18n.get('KNOWDEMSG002')}
                            placement="top-start"
                            arrow={true}
                            open={isShowFlagMessage}
                        >
                            <ButtonOption onClick={onClickCopyShareLink}>
                                <span
                                    style={{
                                        fontSize: 15,
                                        fontWeight: 400,
                                        fontFamily: 'Zen Kaku Gothic New'
                                    }}
                                >
                                    {I18n.get('GET_URL')}
                                </span>
                            </ButtonOption>
                        </FlagMessageCopyLink>
                    )}
                    {!Utils.isEmptyObject(openFileOption) &&
                        !openFileOption?.originId?.includes('post') && (
                            <ButtonOption
                                disabled={isDisable}
                                onClick={() => {
                                    if (!openFileOption?.isNewImg) {
                                        deleteFile(
                                            openFileOption?.index + openFileOption?.imageLength
                                        );
                                    } else {
                                        handleDeleteFile(openFileOption?.index);
                                    }
                                }}
                            >
                                <span
                                    style={{
                                        fontSize: 15,
                                        fontWeight: 400,
                                        fontFamily: 'Zen Kaku Gothic New'
                                    }}
                                >
                                    {I18n.get('DELETE')}
                                </span>
                            </ButtonOption>
                        )}
                </div>
            </Popover>

            <Dialog
                open={!!openPreviewImage}
                onClose={() => setOpenPreviewImage(null)}
                maxWidth="md"
            >
                <img
                    alt=""
                    src={openPreviewImage}
                    style={{
                        maxWidth: '90vw',
                        maxHeight: '90vh',
                        objectFit: 'contain'
                    }}
                />
            </Dialog>
        </div>
    );
};

EditFileUploaded.propTypes = {
    fileUploadList: PropTypes.any,
    setFileUploadList: PropTypes.any,
    fileUpdatedList: PropTypes.any,
    setValue: PropTypes.any,
    register: PropTypes.any,
    listFieldEdited: PropTypes.any,
    componentName: PropTypes.any,
    addTicket: PropTypes.any,
    setFileUpdatedList: PropTypes.any,
    name: PropTypes.any,
    detailTicket: PropTypes.any,
    setIsShowPopupLogout: PropTypes.any,
    panelId: PropTypes.any,
    tabId: PropTypes.any,
    panelInitData: PropTypes.any,
    setPanelInitData: PropTypes.any,
    hasEditFieldPermissions: PropTypes.any,
    selectTicketType: PropTypes.any,
    ticketType: PropTypes.any,
    setShowButtonEditTicket: PropTypes.any,
    data: PropTypes.any,
    defaultValue: PropTypes.any,
    isTriggerReloadCurrentTicket: PropTypes.any,
    fileDeletedList: PropTypes.any,
    isEmail: PropTypes.any,
    isDisableEdit: PropTypes.any,
    attachmentError: PropTypes.any,
    allowMultipleFiles: PropTypes.bool,
    acceptedFileExtensions: PropTypes.array,
    limitFileSize: PropTypes.number,
    setIsEdited: PropTypes.func,
    setOnChangeEdit: PropTypes.func,
    onChangeEdit: PropTypes.bool,
    setListFieldEdited: PropTypes.func,
    clearErrors: PropTypes.func,
    setErrorCreateTicket: PropTypes.func,
    currentPanelInitData: PropTypes.object,
    parentForm: PropTypes.object,
    note: PropTypes.string,
    isShowIconCopyFieldId: PropTypes.bool
};
